
const ServiceTerms = () => {
  return (
    <div style={{ padding: "1% 10%" }}>
      <h1 style={{marginBottom:"0.5em"}}>Términos de Servicio de Fiva</h1>
      <p>Última actualización: 13 de julio del 2023</p>
      <hr />
      <section style={{padding:"1% 0%"}}>
        <p>
          Los presentes términos de servicio establecen los derechos y
          responsabilidades tanto del proveedor de la plataforma como de los
          usuarios que la utilizan. Antes de acceder y utilizar nuestra
          plataforma, te pedimos que leas detenidamente estos términos para
          comprender plenamente cómo funcionan nuestros servicios y cómo se
          aplican a tu interacción con la plataforma.
        </p>
        <p>
          Nuestra plataforma web tiene como objetivo principal ayudarte a
          mejorar la eficiencia de tu suministro eléctrico y reducir tus gastos
          en energía. Mediante un análisis detallado de tu factura de luz,
          extraemos información personal y de suministro eléctrico para
          ofrecerte las mejores opciones de tarifas disponibles en el mercado.
          Si decides seleccionar una tarifa, te guiaremos a través del proceso
          de recopilación de datos adicionales y firma necesarios para generar
          los contratos de la comercializadora seleccionada.
        </p>
        <p>
          Es importante destacar que, al utilizar nuestra plataforma, aceptas
          cumplir con estos términos de servicio, así como con cualquier
          política adicional que pueda aplicarse. Si no estás de acuerdo con
          alguno de estos términos, te pedimos que no utilices nuestra
          plataforma.
        </p>
        <p>
          Nuestro compromiso es brindarte un servicio de calidad y garantizar la
          privacidad y seguridad de tus datos personales. Te invitamos a revisar
          nuestra{" "}
          <a href="politica-de-privacidad.html">política de privacidad</a> para
          obtener más detalles sobre cómo manejamos la información que nos
          proporcionas.
        </p>
        <p>
          Te recomendamos que consultes regularmente los términos de servicio,
          ya que podrían actualizarse periódicamente para reflejar cambios en
          nuestras operaciones o en las leyes y regulaciones aplicables.
          Cualquier modificación de estos términos se te notificará de acuerdo
          con los procedimientos establecidos.
        </p>
        <p>
          Gracias por elegir nuestra plataforma web. Esperamos que encuentres en
          ella una herramienta útil para optimizar tus gastos de energía y
          mejorar tu experiencia en el suministro eléctrico. Si tienes alguna
          pregunta o inquietud, no dudes en contactarnos a través de los canales
          de soporte proporcionados.
        </p>
        <p>
          ¡Bienvenido(a) a nuestra plataforma y disfruta de los beneficios que
          podemos ofrecerte!
        </p>
      </section>

      <section style={{padding:"1% 0%"}}>
        <h1 style={{marginBottom:"0.5em"}}>Interpretación y Definiciones</h1>
        <ul>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Plataforma web</strong>: se refiere a la plataforma FIVA,
            que incluye el sitio web y todos los servicios relacionados
            proporcionados por FIVA E&S SOLUTIONS, SL, a través de los cuales
            los usuarios pueden subir sus facturas de luz, acceder a análisis y
            recomendaciones de tarifas, y seleccionar una tarifa que se ajuste a
            sus necesidades.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Proveedor</strong>: se refiere a FIVA E&S SOLUTIONS, SL, la
            empresa propietaria y operadora de la plataforma web FIVA.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Usuario</strong>: se refiere a cualquier persona o entidad
            que accede y utiliza la plataforma web FIVA, incluyendo a los
            clientes que suben sus facturas de luz, revisan las recomendaciones
            de tarifas y eligen una tarifa para su suministro eléctrico.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Factura de luz</strong>: se refiere al documento emitido por
            la compañía de suministro eléctrico que detalla el consumo de
            energía, los cargos aplicados, los datos personales del cliente y
            otra información relevante relacionada con el suministro eléctrico.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Datos personales</strong>: se refiere a toda la información
            que identifica o se puede utilizar para identificar a un individuo,
            incluyendo, entre otros, el nombre, la dirección, el número de
            teléfono, la dirección de correo electrónico y la firma del usuario.
            La firma del usuario es recopilada y utilizada para completar los
            contratos de la comercializadora seleccionada a través de la
            plataforma web FIVA operada por FIVA E&S SOLUTIONS, SL.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Tarifas</strong>: se refiere a las opciones de precios y
            condiciones ofrecidas por las comercializadoras de energía para el
            suministro eléctrico, que se muestran al usuario en la plataforma
            web FIVA con el objetivo de que este elija una opción para
            optimizar su factura de luz.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Comercializadora</strong>: se refiere a la empresa o entidad
            que se dedica a la venta y comercialización de energía eléctrica.
            Una vez que el usuario selecciona una tarifa en la plataforma web
            FIVA, FIVA E&S SOLUTIONS, SL utiliza los datos proporcionados por
            el usuario, incluida su firma, para tramitar el contrato con la
            comercializadora seleccionada en nombre del usuario.
          </li>
        </ul>
      </section>

      <section style={{padding:"1% 0%"}}>
        <h1 style={{marginBottom:"0.5em"}}>Aceptación de los Términos</h1>
        <p>
          Al acceder o utilizar la plataforma web FIVA, aceptas cumplir y
          estar sujeto a estos términos de servicio, así como a cualquier
          política adicional que pueda aplicarse. Esta aceptación se considera
          válida y vinculante tanto para los usuarios individuales como para las
          entidades comerciales.
        </p>
        <ul>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Uso adecuado de la plataforma:</strong> Te comprometes a
            utilizar la plataforma web FIVA únicamente con fines legales y de
            acuerdo con estos términos de servicio. No debes utilizar la
            plataforma de manera que infrinja los derechos de terceros o viole
            cualquier ley, normativa o regulación aplicable.
          </li>

          <li style={{marginBottom:"0.5em"}}>
            <strong>Acceso y cuentas de usuario:</strong> Para acceder a ciertas
            funciones o servicios de la plataforma, es posible que debas crear
            una cuenta de usuario. Al hacerlo, te comprometes a proporcionar
            información precisa, actualizada y completa, y a mantener la
            confidencialidad de tus credenciales de inicio de sesión. Eres
            responsable de todas las actividades que ocurran bajo tu cuenta.
          </li>

          <li style={{marginBottom:"0.5em"}}>
            <strong>Datos personales y privacidad:</strong> Reconoces y aceptas
            que FIVA E&S SOLUTIONS, SL recopilará, utilizará y protegerá tus
            datos personales de acuerdo con su política de privacidad. Al
            utilizar la plataforma, otorgas tu consentimiento para el uso de tus
            datos personales conforme a dicha política.
          </li>

          <li style={{marginBottom:"0.5em"}}>
            <strong>Propiedad intelectual:</strong> Reconoces y aceptas que FIVA
            E&S SOLUTIONS, SL es propietaria de todos los derechos de propiedad
            intelectual asociados a la plataforma web FIVA, incluyendo
            software, diseños, logotipos y otros contenidos. No se te concede
            ningún derecho o licencia sobre estos elementos, excepto en la
            medida necesaria para utilizar la plataforma de acuerdo con estos
            términos de servicio.
          </li>

          <li style={{marginBottom:"0.5em"}}>
            <strong>Responsabilidades del usuario:</strong> Asumes toda la
            responsabilidad por el uso de la plataforma web FIVA y garantizas
            que la información que proporcionas es precisa y actualizada. Te
            comprometes a utilizar la plataforma de acuerdo con estos términos
            de servicio, las leyes y regulaciones aplicables, y a respetar los
            derechos de propiedad intelectual de FIVA E&S SOLUTIONS, SL.
          </li>

          <li style={{marginBottom:"0.5em"}}>
            <strong>Limitaciones de responsabilidad:</strong> Reconoces y
            aceptas que el uso de la plataforma es bajo tu propio riesgo. FIVA
            E&S SOLUTIONS, SL no será responsable de cualquier daño directo,
            indirecto, incidental, especial, consecuente o punitivo derivado del
            uso o la incapacidad de utilizar la plataforma, incluso si se ha
            advertido sobre la posibilidad de dichos daños.
          </li>

          <li style={{marginBottom:"0.5em"}}>
            <strong>Modificaciones de los términos:</strong> FIVA E&S SOLUTIONS,
            SL se reserva el derecho de modificar estos términos de servicio en
            cualquier momento. Las modificaciones entrarán en vigor al ser
            publicadas en la plataforma web FIVA. Te recomendamos revisar
            periódicamente los términos para estar al tanto de las
            actualizaciones.
          </li>
        </ul>
      </section>

      <section style={{padding:"1% 0%"}}>
        <h1 style={{marginBottom:"0.5em"}}>Descripción del Servicio</h1>

        <p>
          La plataforma web FIVA proporcionada por FIVA E&S SOLUTIONS, SL
          ofrece a los usuarios la oportunidad de optimizar sus facturas de luz
          y mejorar su experiencia en el suministro eléctrico. A través de
          nuestra plataforma, brindamos servicios de análisis de facturas,
          recomendaciones de tarifas y asistencia en el proceso de contratación
          con comercializadoras de energía.
        </p>

        <p>
          El servicio se inicia con la opción de carga de la factura de luz por
          parte del usuario. Nuestra plataforma utiliza tecnología avanzada para
          analizar la factura y extraer los datos personales y de suministro
          eléctrico relevantes. Esto nos permite generar recomendaciones
          personalizadas de tarifas que se ajusten a las necesidades y
          preferencias del usuario.
        </p>

        <p>
          Una vez que el usuario revisa las opciones de tarifas recomendadas,
          puede seleccionar la que mejor se adapte a sus requisitos. En ese
          momento, la plataforma solicitará al usuario datos adicionales
          necesarios para completar el proceso de contratación, como información
          de contacto, datos bancarios y firma digital.
        </p>

        <p>
          Con la información proporcionada por el usuario y su firma digital,
          FIVA E&S SOLUTIONS, SL se encarga de tramitar el contrato con la
          comercializadora seleccionada en nombre del usuario. Esto simplifica y
          agiliza el proceso de contratación, evitando al usuario la necesidad
          de lidiar directamente con la comercializadora.
        </p>

        <p>
          Es importante tener en cuenta que FIVA E&S SOLUTIONS, SL actúa como
          intermediario en el proceso de contratación y no asume responsabilidad
          por las acciones o servicios proporcionados por la comercializadora.
          Cualquier problema o consulta relacionada con el suministro eléctrico
          o el contrato debe ser dirigida directamente a la comercializadora
          correspondiente.
        </p>

        <p>
          La plataforma FIVA se esfuerza por brindar un servicio eficiente y
          confiable, utilizando tecnología segura para proteger la privacidad y
          los datos personales de los usuarios. Sin embargo, es importante tener
          en cuenta que el análisis de las facturas y las recomendaciones de
          tarifas son estimaciones basadas en la información proporcionada por
          el usuario, y los resultados pueden variar según las políticas y
          condiciones de las comercializadoras.
        </p>

        <p>
          Estamos comprometidos a mejorar continuamente nuestra plataforma y
          ampliar los servicios ofrecidos para brindar a los usuarios una
          experiencia satisfactoria y resultados óptimos en su factura de luz.
        </p>

        <p>
          Si tienes alguna pregunta o necesitas más información sobre nuestro
          servicio, no dudes en contactarnos. Estaremos encantados de ayudarte,
          puedes escribirnos a <a href="contacto@fiva.es">contacto@fiva.es</a>
        </p>
      </section>
      <section style={{padding:"1% 0%"}}>
        <h1 style={{marginBottom:"0.5em"}}>Propiedad Intelectual</h1>
        <p>
          <strong>FIVA E&S SOLUTIONS, SL</strong> es el titular de todos los
          derechos de propiedad intelectual asociados a la plataforma web FIVA
          y sus componentes. Esto incluye, pero no se limita a, software,
          diseño, logotipos, gráficos, imágenes, textos y cualquier otro
          contenido presente en la plataforma.
        </p>

        <p>
          Al utilizar la plataforma web FIVA, reconoces y aceptas que estos
          derechos de propiedad intelectual están protegidos por las leyes de
          propiedad intelectual aplicables. Queda estrictamente prohibido
          copiar, modificar, distribuir, transmitir, mostrar, reproducir,
          publicar, conceder licencias, crear trabajos derivados o utilizar de
          cualquier otra manera los elementos protegidos sin el consentimiento
          expreso y por escrito de FIVA E&S SOLUTIONS, SL.
        </p>

        <p>
          Además, reconoces y aceptas que cualquier contenido generado por los
          usuarios y compartido en la plataforma web FIVA sigue siendo
          propiedad de los respectivos usuarios. Sin embargo, al utilizar la
          plataforma, otorgas a FIVA E&S SOLUTIONS, SL una licencia no
          exclusiva, perpetua, irrevocable, libre de regalías y sublicenciable
          para utilizar, reproducir, modificar, adaptar, publicar, traducir,
          distribuir y mostrar dicho contenido con fines relacionados con la
          prestación de los servicios de la plataforma.
        </p>

        <p>
          Cualquier uso no autorizado de los derechos de propiedad intelectual
          de FIVA E&S SOLUTIONS, SL puede dar lugar a acciones legales y
          reclamaciones por daños y perjuicios.
        </p>

        <p>
          Si tienes alguna pregunta sobre los derechos de propiedad intelectual
          o necesitas obtener permiso para utilizar algún contenido específico
          de la plataforma web FIVA, te invitamos a ponerte en contacto con
          nosotros para solicitar la correspondiente autorización.
        </p>

        <p>
          Recuerda que el respeto a la propiedad intelectual es fundamental para
          mantener un ambiente adecuado en la plataforma y proteger los derechos
          de todos los involucrados.
        </p>
      </section>
      <section style={{padding:"1% 0%"}}>
        <h1 style={{marginBottom:"0.5em"}}>Privacidad y Protección de Datos</h1>
        <ol>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Recopilación de datos:</strong> Al utilizar la plataforma
            web FIVA, es posible que se te solicite proporcionar los
            siguientes campos necesarios para cumplir con la ley de protección
            de datos:
            <ul>
              <li style={{marginBottom:"0.5em"}}>
                Nombre completo: Para identificarte de manera adecuada y
                personalizar la experiencia en la plataforma.
              </li>
              <li style={{marginBottom:"0.5em"}}>
                Dirección: Para fines de contacto y facilitar el proceso de
                contratación con la comercializadora seleccionada.
              </li>
              <li style={{marginBottom:"0.5em"}}>
                Número de teléfono: Para comunicarnos contigo en relación con tu
                cuenta y servicios relacionados.
              </li>
              <li style={{marginBottom:"0.5em"}}>
                Dirección de correo electrónico: Para enviar información
                relevante sobre tu cuenta y servicios de la plataforma.
              </li>
              <li style={{marginBottom:"0.5em"}}>
                Datos bancarios: Si es necesario para el proceso de
                contratación, podríamos solicitar información bancaria segura
                para realizar transacciones.
              </li>
            </ul>
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Uso de datos:</strong> Los datos personales recopilados se
            utilizan para los siguientes fines:
            <ul>
              <li style={{marginBottom:"0.5em"}}>
                Realizar el análisis de tu factura de luz y generar
                recomendaciones de tarifas adecuadas a tu perfil de consumo.
              </li>
              <li style={{marginBottom:"0.5em"}}>
                Facilitar el proceso de contratación con la comercializadora
                seleccionada, utilizando la información y la firma
                proporcionadas por ti.
              </li>
              <li style={{marginBottom:"0.5em"}}>
                Comunicarnos contigo para brindarte actualizaciones, información
                relevante sobre tu cuenta y servicios relacionados con la
                plataforma FIVA.
              </li>
              <li style={{marginBottom:"0.5em"}}>
                Mejorar nuestros servicios, realizar análisis estadísticos y
                desarrollar nuevas funcionalidades de la plataforma.
              </li>
            </ul>
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Protección de datos:</strong> Implementamos medidas técnicas
            y organizativas adecuadas para garantizar la seguridad de tus datos
            personales y protegerlos contra acceso no autorizado, pérdida,
            alteración o divulgación indebida. Además, nos aseguramos de que
            cualquier tercero con el que compartamos tus datos tenga las medidas
            de seguridad adecuadas en vigor.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Compartir datos:</strong> En determinadas circunstancias,
            podemos compartir tus datos personales con terceros, como las
            comercializadoras de energía para el proceso de contratación. Sin
            embargo, solo compartimos la información necesaria para cumplir con
            los fines establecidos y nos aseguramos de que dichos terceros
            también cumplan con las leyes y regulaciones de protección de datos.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Retención de datos:</strong> Conservamos tus datos
            personales durante el tiempo necesario para cumplir con los fines
            para los que se recopilaron, así como para cumplir con nuestras
            obligaciones legales y resolver cualquier disputa. Cuando ya no sean
            necesarios, eliminaremos o anonimizaremos tus datos de forma segura.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Tus derechos:</strong> Tienes derecho a acceder, corregir,
            actualizar o eliminar tus datos personales que tenemos en nuestra
            posesión. También puedes oponerte al procesamiento de tus datos o
            solicitar la limitación de su uso. Si deseas ejercer alguno de estos
            derechos o tienes alguna pregunta sobre el manejo de tus datos,
            puedes contactarnos utilizando la información de contacto
            proporcionada al final de estos términos.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Cookies y tecnologías similares:</strong> Utilizamos cookies
            y tecnologías similares para mejorar tu experiencia en la
            plataforma. Puedes ajustar tus preferencias de cookies a través de
            la configuración de tu navegador, pero ten en cuenta que esto puede
            afectar la funcionalidad de la plataforma.
          </li>
        </ol>

        <p>
          Para obtener más información sobre cómo recopilamos, utilizamos y
          protegemos tus datos personales, así como sobre tus derechos y
          opciones, te invitamos a consultar nuestra política de privacidad, que
          se encuentra disponible en la plataforma web FIVA.
        </p>
      </section>
      <section style={{padding:"1% 0%"}}>
        <h1>Responsabilidades del Usuario</h1>
        <p>
          Al utilizar la plataforma web FIVA proporcionada por FIVA E&S
          SOLUTIONS, SL, como usuario, tienes ciertas responsabilidades y
          obligaciones. A continuación, se detallan las principales
          responsabilidades del usuario:
        </p>
        <ul>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Exactitud de la información:</strong> Te comprometes a
            proporcionar información precisa, actualizada y completa al utilizar
            la plataforma.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Uso adecuado de la plataforma:</strong> Te comprometes a
            utilizar la plataforma web FIVA de acuerdo con estos términos de
            servicio y las leyes y regulaciones aplicables.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>
              Confidencialidad de tus credenciales de inicio de sesión:
            </strong>{" "}
            Eres responsable de mantener la confidencialidad de tus credenciales
            de inicio de sesión.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Uso de los servicios de la plataforma:</strong> Al utilizar
            la plataforma web FIVA, aceptas que eres el único responsable de
            todas las decisiones que tomes basadas en las recomendaciones de
            tarifas proporcionadas.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Cumplimiento de las leyes y regulaciones:</strong> Te
            comprometes a cumplir con todas las leyes, regulaciones y requisitos
            legales aplicables al utilizar la plataforma web FIVA.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Comunicación y colaboración adecuadas:</strong> En caso de
            tener alguna consulta, duda o problema relacionado con la
            plataforma, te comprometes a comunicarte de manera adecuada y
            respetuosa con FIVA E&S SOLUTIONS, SL.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Uso responsable de la plataforma:</strong> Te comprometes a
            utilizar la plataforma de manera responsable, evitando cualquier
            actividad que pueda causar daño o afectar la disponibilidad,
            integridad o seguridad de la plataforma.
          </li>
        </ul>

        <p>
          Recuerda que el incumplimiento de estas responsabilidades puede
          resultar en la suspensión o terminación de tu acceso a la plataforma
          web FIVA. Además, si tu conducta viola las leyes y regulaciones
          aplicables, FIVA E&S SOLUTIONS, SL se reserva el derecho de tomar las
          acciones legales correspondientes.
        </p>
      </section>
      <section style={{padding:"1% 0%"}}>
        <h1 style={{marginBottom:"0.5em"}}>Proceso de Contratación</h1>
        <ol>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Recopilación de datos adicionales:</strong> Para completar
            el proceso de contratación, se te solicitará proporcionar
            información adicional, como datos de contacto, detalles bancarios y
            cualquier otro dato necesario para la contratación del suministro
            eléctrico.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Firma del contrato:</strong> Como parte del proceso de
            contratación, se te pedirá que proporciones una firma digital o
            electrónica para validar y autorizar el contrato con la
            comercializadora seleccionada.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Tramitación del contrato:</strong> Una vez que hayas
            proporcionado los datos requeridos y firmado el contrato, FIVA E&S
            SOLUTIONS, SL se encargará de tramitar el contrato en tu nombre con
            la comercializadora elegida.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Validación por parte de la comercializadora:</strong>{" "}
            Después de que se haya tramitado el contrato, la comercializadora
            puede realizar una validación adicional para verificar la
            información proporcionada y confirmar la contratación del suministro
            eléctrico.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Confirmación y activación del suministro:</strong> Una vez
            que la comercializadora haya validado y aceptado el contrato,
            recibirás una confirmación de la contratación y se procederá a la
            activación del suministro eléctrico.
          </li>
        </ol>

        <p>
          Es importante tener en cuenta que FIVA E&S SOLUTIONS, SL actúa como
          intermediario en el proceso de contratación y no asume responsabilidad
          por los servicios o acciones de la comercializadora. Cualquier
          consulta, duda o reclamación relacionada con el suministro eléctrico
          debe dirigirse directamente a la comercializadora correspondiente.
        </p>

        <p>
          Si tienes alguna pregunta o necesitas más información sobre el proceso
          de contratación a través de la plataforma web FIVA, no dudes en
          contactarnos. Estaremos encantados de ayudarte y brindarte la
          asistencia necesaria.
        </p>
      </section>
      <section style={{padding:"1% 0%"}}>
        <h1 style={{marginBottom:"0.5em"}}>Limitaciones de Responsabilidad</h1>
        <p>
          Al utilizar la plataforma web FIVA proporcionada por FIVA E&S
          SOLUTIONS, SL, es importante tener en cuenta las siguientes
          limitaciones de responsabilidad:
        </p>
        <ul>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Uso bajo tu propio riesgo:</strong> Reconoces y aceptas que
            el uso de la plataforma FIVA se realiza bajo tu propio riesgo. La
            plataforma se proporciona tal cual y según disponibilidad. FIVA
            E&S SOLUTIONS, SL no garantiza la disponibilidad, precisión,
            integridad, confiabilidad o idoneidad de la plataforma para un
            propósito particular. No asumimos responsabilidad por cualquier daño
            o perjuicio resultante del uso o la incapacidad de utilizar la
            plataforma.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Exactitud de la información:</strong> Aunque nos esforzamos
            por ofrecer recomendaciones precisas y actualizadas sobre las
            tarifas de energía, debes tener en cuenta que los resultados pueden
            variar y dependen de la información proporcionada por ti. No podemos
            garantizar la exactitud o veracidad de la información contenida en
            la plataforma, incluyendo las tarifas y las condiciones ofrecidas
            por las comercializadoras de energía.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Responsabilidad de las comercializadoras:</strong> FIVA E&S
            SOLUTIONS, SL actúa como intermediario en el proceso de
            contratación, facilitando la relación entre los usuarios y las
            comercializadoras de energía. No asumimos responsabilidad por los
            servicios, productos o acciones de las comercializadoras. Cualquier
            problema, disputa o reclamación relacionada con el suministro
            eléctrico debe ser dirigida directamente a la comercializadora
            correspondiente.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Limitación de daños:</strong> En la medida permitida por la
            ley aplicable, FIVA E&S SOLUTIONS, SL no será responsable por ningún
            daño directo, indirecto, incidental, especial, consecuente o
            punitivo, incluyendo, entre otros, pérdida de datos, ingresos,
            ganancias o daños a la reputación, derivados del uso o la
            incapacidad de utilizar la plataforma.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Exoneración de responsabilidad:</strong> Aceptas exonerar y
            mantener indemne a FIVA E&S SOLUTIONS, SL y a sus directores,
            empleados y agentes de cualquier reclamación, demanda, acción,
            pérdida, responsabilidad o gasto, incluyendo los honorarios
            razonables de abogados, que surjan o estén relacionados con tu uso
            de la plataforma FIVA o cualquier incumplimiento de estos términos
            de servicio.
          </li>
        </ul>
        <p>
          Es importante tener en cuenta estas limitaciones de responsabilidad al
          utilizar la plataforma web FIVA. Si tienes alguna pregunta o
          inquietud relacionada con estas limitaciones, te recomendamos ponerte
          en contacto con nosotros para obtener más información.
        </p>
        <p>
          Recuerda que estas limitaciones de responsabilidad no afectan tus
          derechos legales en virtud de las leyes aplicables, y en caso de que
          alguna disposición de estos términos de servicio sea considerada
          inválida o inaplicable, las demás disposiciones seguirán siendo
          válidas y aplicables en la máxima medida permitida por la ley.
        </p>
      </section>
      <section style={{padding:"1% 0%"}}>
        <h1 style={{marginBottom:"0.5em"}}>Cancelación y Término de Servicio</h1>
        <p>
          En el caso de que desees cancelar tu uso de la plataforma web FIVA
          proporcionada por FIVA E&S SOLUTIONS, SL, o dar por terminados estos
          términos de servicio, a continuación, se describen los aspectos
          relevantes relacionados con la cancelación y el término del servicio:
        </p>
        <ul>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Cancelación por parte del usuario:</strong> Tienes el
            derecho de cancelar tu cuenta y dejar de utilizar la plataforma en
            cualquier momento. Para cancelar tu cuenta, puedes comunicarte con
            nosotros a través de los canales de contacto proporcionados en la
            plataforma. Ten en cuenta que la cancelación de tu cuenta puede
            resultar en la pérdida de acceso a ciertos servicios y
            funcionalidades de la plataforma.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Terminación por parte de FIVA E&S SOLUTIONS, SL:</strong>{" "}
            Nos reservamos el derecho de dar por terminados estos términos de
            servicio y suspender o cancelar tu acceso a la plataforma FIVA en
            cualquier momento y por cualquier motivo, incluyendo, entre otros,
            el incumplimiento de estos términos o cualquier actividad que
            consideremos inapropiada, ilegal o perjudicial para la plataforma o
            para otros usuarios.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Efecto de la cancelación o terminación:</strong> En caso de
            cancelación o terminación, se te solicitará dejar de utilizar la
            plataforma y cualquier contenido, información o datos relacionados
            con tu cuenta. FIVA E&S SOLUTIONS, SL puede retener cierta
            información relacionada con tu cuenta de acuerdo con nuestras
            políticas de retención de datos o según lo exijan las leyes y
            regulaciones aplicables.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>
              Consecuencias posteriores a la cancelación o terminación:
            </strong>{" "}
            Después de la cancelación o terminación, no seremos responsables por
            la pérdida de acceso a la plataforma o a cualquier contenido,
            información o datos relacionados. Te recomendamos tomar las medidas
            necesarias para respaldar y guardar cualquier información importante
            antes de la cancelación o terminación de tu cuenta.
          </li>
        </ul>
        <p>
          Es importante tener en cuenta que, independientemente de la
          cancelación o terminación, ciertas disposiciones de estos términos de
          servicio seguirán siendo aplicables, como las relacionadas con la
          propiedad intelectual, limitaciones de responsabilidad y protección de
          datos.
        </p>
        <p>
          Si tienes alguna pregunta o necesitas más información sobre la
          cancelación o término del servicio, te recomendamos ponerte en
          contacto con nosotros para obtener la asistencia necesaria.
        </p>
        <p>
          Ten en cuenta que estos términos de servicio están sujetos a cambios y
          actualizaciones periódicas. Te recomendamos revisar regularmente los
          términos de servicio para estar al tanto de cualquier modificación.
        </p>
      </section>
      <section style={{padding:"1% 0%"}}>
        <h1>Modificaciones de los Términos de Servicio</h1>
        <p>
          FIVA E&S SOLUTIONS, SL se reserva el derecho de realizar
          modificaciones o actualizaciones a estos términos de servicio en
          cualquier momento y a su entera discreción. Cuando se realicen cambios
          significativos en los términos, se te notificará mediante un aviso en
          la plataforma web FIVA o a través de otros medios de comunicación
          adecuados.
        </p>
        <p>
          Es importante que revises regularmente los términos de servicio para
          estar al tanto de cualquier modificación. El uso continuado de la
          plataforma después de la publicación de los cambios constituirá tu
          aceptación de los términos modificados. Si no estás de acuerdo con los
          nuevos términos, debes dejar de utilizar la plataforma.
        </p>
        <p>
          Además, ten en cuenta que ciertos aspectos de la plataforma pueden
          estar sujetos a términos y condiciones adicionales o políticas
          específicas. Estos términos adicionales se proporcionarán de manera
          clara y se considerarán parte integral de los términos de servicio.
        </p>
        <p>
          FIVA E&S SOLUTIONS, SL se esforzará por proporcionar una notificación
          adecuada y suficiente de cualquier modificación de los términos de
          servicio. Sin embargo, es tu responsabilidad revisar regularmente los
          términos para estar al tanto de cualquier cambio.
        </p>
        <p>
          Si tienes alguna pregunta o inquietud sobre las modificaciones de los
          términos de servicio, te recomendamos ponerte en contacto con nosotros
          para obtener más información y aclaraciones.
        </p>
        <p>
          Recuerda que estos términos de servicio son vinculantes y establecen
          la relación entre tú y FIVA E&S SOLUTIONS, SL en relación con el uso
          de la plataforma web FIVA.
        </p>
      </section>
      <section style={{padding:"1% 0%"}}>
        <h1 style={{marginBottom:"0.5em"}}>Ley Aplicable y Jurisdicción</h1>
        <p>
          Estos términos de servicio y cualquier disputa o reclamación
          relacionada con el uso de la plataforma web FIVA se regirán e
          interpretarán de acuerdo con las leyes del país o región
          correspondiente en el que opera FIVA E&S SOLUTIONS, SL.
        </p>
        <p>
          Cualquier disputa o reclamación que surja de o en relación con estos
          términos de servicio, incluyendo cualquier cuestión relativa a su
          existencia, validez, interpretación, ejecución o terminación, será
          sometida a la jurisdicción exclusiva de los tribunales competentes en
          el país o región correspondiente en el que opera FIVA E&S SOLUTIONS,
          SL.
        </p>
        <p>
          FIVA E&S SOLUTIONS, SL y tú acuerdan someterse a la jurisdicción
          exclusiva de dichos tribunales y renuncian a cualquier objeción a la
          conveniencia o competencia de tales tribunales para resolver cualquier
          disputa o reclamación.
        </p>
        <p>
          En caso de que alguna disposición de estos términos de servicio sea
          considerada inválida o inaplicable por un tribunal competente, las
          demás disposiciones seguirán siendo válidas y aplicables en la máxima
          medida permitida por la ley.
        </p>
        <p>
          Si tienes alguna pregunta o inquietud sobre la ley aplicable y la
          jurisdicción relacionada con estos términos de servicio, te
          recomendamos ponerte en contacto con nosotros para obtener más
          información y asesoramiento legal específico.
        </p>
      </section>
      <section style={{padding:"1% 0%"}}>
        <h1 style={{marginBottom:"0.5em"}}>Disposiciones Generales</h1>
        <ol>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Independencia de las partes:</strong> Estos términos de
            servicio no crean ninguna relación de agencia, asociación, sociedad,
            empleo u otro tipo de relación similar entre tú y FIVA E&S
            SOLUTIONS, SL. Eres un usuario independiente de la plataforma web
            FIVA y no tienes autoridad para actuar en nombre de FIVA E&S
            SOLUTIONS, SL.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Cesión:</strong> No puedes ceder, transferir ni sublicenciar
            tus derechos y obligaciones establecidos en estos términos de
            servicio sin el consentimiento previo y por escrito de FIVA E&S
            SOLUTIONS, SL. Sin embargo, FIVA E&S SOLUTIONS, SL puede ceder,
            transferir o delegar estos términos a terceros sin restricciones.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Acuerdo completo:</strong> Estos términos de servicio
            constituyen el acuerdo completo entre tú y FIVA E&S SOLUTIONS, SL en
            relación con el uso de la plataforma web FIVA y reemplazan
            cualquier acuerdo o entendimiento previo, ya sea escrito o verbal,
            en relación con el mismo tema.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Renuncia:</strong> La falta de ejercicio por parte de FIVA
            E&S SOLUTIONS, SL de cualquier derecho o disposición establecida en
            estos términos de servicio no se considerará una renuncia a dicho
            derecho o disposición. Cualquier renuncia debe ser específica y por
            escrito para ser válida.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Divisibilidad:</strong> Si alguna disposición de estos
            términos de servicio se considera inválida, ilegal o inaplicable por
            un tribunal competente, dicha disposición se interpretará en la
            máxima medida permitida por la ley para reflejar las intenciones
            originales de las partes, y las demás disposiciones seguirán siendo
            válidas y aplicables.
          </li>
          <li style={{marginBottom:"0.5em"}}>
            <strong>Comunicaciones:</strong> Las comunicaciones entre tú y FIVA
            E&S SOLUTIONS, SL relacionadas con la plataforma web FIVA se
            realizarán principalmente a través de los canales de comunicación
            proporcionados en la plataforma. Aceptas recibir comunicaciones
            electrónicas y reconoces que dichas comunicaciones satisfacen
            cualquier requisito legal de comunicación por escrito.
          </li>
        </ol>
        <p>
          Si tienes alguna pregunta o necesitas más información sobre las
          disposiciones generales de estos términos de servicio, te recomendamos
          ponerte en contacto con nosotros. Estaremos encantados de brindarte
          aclaraciones adicionales.
        </p>
      </section>
    </div>
  )
}
export default ServiceTerms
